import { Component, OnInit } from '@angular/core';
import { GenericService } from '../services/generic.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  public currentCount = 0;
  public item1 = '';
  public item2 = '';
  public theHtmlString ="";
  retItem: any;

  public slideIndex: any = 1;
 // public slideIndex: any = 1;

  constructor(private genericService: GenericService,) { 


  }

  ngOnInit() {

this.LoadData();
// this.doImages();



  }

  doImages(){

}










  LoadData() {
    
        this.genericService.getItem(224).subscribe((data) => {
          this.retItem = data;
          console.log(this.retItem);
       //   if (this.retItem.length > 0) {
           this.currentCount = this.retItem.length;
            this.item1 = this.retItem.name;
            this.item2 = this.retItem.name_sub;
            this.theHtmlString = this.retItem.html_content;
          //  alert("data here");
          //   this.dataavailbale = true;
          // }
          // else {
          //   this.dataavailbale = false;
       //   }
    
    
        }
        )
          , err => {
            console.log(err);
          }
      }

}
